import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

const useSessionChecker = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const token = sessionStorage.getItem("accessToken");

    if (!token) {
      navigate("/", { replace: true });
      return;
    }

    try {
      const [, payloadBase64] = token.split(".");
      const payload = JSON.parse(atob(payloadBase64));
      const isExpired = Date.now() >= payload.exp * 1000;

      if (isExpired) {
        sessionStorage.removeItem("accessToken");
        window.location.href = "/login"; // force redirect
      }
    } catch {
      sessionStorage.removeItem("accessToken");
      window.location.href = "/login"; // force redirect
    }
  }, []);
};

export default useSessionChecker;
